import request from '../../../shared/request'

export function getJobSiteChangeOrders(job_id) {
  return request(`/job/job_site_change_orders/${job_id}/`)
}

export function createJobSiteChangeOrder(payload) {
  return request(`/job/job_site_change_orders/${payload.change_order_data.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobSiteChangeOrder(payload) {
  return request(`/job/job_site_change_orders/${payload.change_order_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSiteChangeOrder(payload) {
  return request(`/job/job_site_change_orders/${payload.job_site_change_order_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getChangeOrderItems(estimateId) {
  return request(`/job/job_site_change_orders/${estimateId}/items`)
}

export function uploadAttachments(payload) {
  return request(`/job/job_site_change_orders/${payload.changeOrderId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(changeOrderId) {
  return request(`/job/job_site_change_orders/${changeOrderId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_site_change_orders/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_site_change_orders/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function fetchChangeOrderTemplates(job_id) {
  return request(`/job/job_site_change_orders/templates/`)
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteChangeOrders.js